// ACOE Landing Page Mock Data

// Logo URLs
export const logos = {
  light: "https://customer-assets.emergentagent.com/job_rental-experts-1/artifacts/7prx4fdx_acoe_logo_black.png", // For light backgrounds (header)
  dark: "https://customer-assets.emergentagent.com/job_rental-experts-1/artifacts/iy64fsov_acoe_logo_white.png", // For dark backgrounds (footer)
};

export const companyInfo = {
  name: "ACOE",
  tagline: "東京発、ライフスタイル宿泊ブランド",
  taglineEn: "Lifestyle Accommodation Brand from Tokyo",
  description: "物件管理を超えた、ブランドパートナーシップという新しい選択"
};

export const heroContent = {
  headline: "大切な資産を、\n確かな手に。",
  subheadline: "7年間の実績データに基づく、成果報酬型のブランド運営パートナーシップ",
  ctaText: "パートナーシップ適合性を確認",
  ctaTextEn: "Check Partnership Eligibility"
};

export const partnershipFeatures = [
  {
    id: 1,
    title: "ブランド責任",
    titleEn: "Brand Responsibility",
    description: "ACOEブランドとして運営することで、認知度と信頼性を活用。成功も失敗も私たちのブランドに直結します。",
    icon: "Sparkles"
  },
  {
    id: 2,
    title: "運営責任",
    titleEn: "Operation Responsibility",
    description: "ファミリー層に特化した明確な市場ポジショニング戦略と、データドリブンな運営で収益を最大化します。",
    icon: "Settings"
  },
  {
    id: 3,
    title: "収益責任",
    titleEn: "Revenue Responsibility",
    description: "収益最適化と利益改善に注力。オーナー様の経済的成功が、私たちの成功です。",
    icon: "TrendingUp"
  }
];

export const performanceGuarantee = {
  title: "成果保証制度",
  titleEn: "Performance Guarantee",
  description: "結果にコミット、パフォーマンス基準を満たせない月は、運営管理費を免除いたします。",
  highlights: [
    {
      stat: "0円",
      label: "基準未達成月の管理費",
      description: "成果が出なければ、費用は発生しません"
    },
    {
      stat: "7年分",
      label: "実績データ",
      description: "リアルデータに基づく収支シミュレーション"
    },
    {
      stat: "共有",
      label: "リスク&リワード",
      description: "従来のモデルと異なり、リスクも報酬も共有します"
    }
  ]
};

export const brandingBenefits = {
  title: "ブランドの力",
  titleEn: "The Power of Branding",
  subtitle: "単なる物件管理ではなく、確立されたブランド価値の活用",
  benefits: [
    {
      title: "ブランド認知度の活用",
      description: "ACOEブランドの一員として、既存の認知度と信頼をフル活用できます"
    },
    {
      title: "市場差別化",
      description: "競合物件との明確な差別化を実現し、選ばれる理由を創出します"
    },
    {
      title: "資産価値向上",
      description: "長期的な物件価値の向上に貢献し、資産としての魅力を高めます"
    },
    {
      title: "ポートフォリオ拡張性",
      description: "一貫した運営モデルで、複数物件の展開もスムーズに"
    }
  ]
};

export const processSteps = [
  {
    step: 1,
    title: "物件情報のご提供",
    description: "基本的な物件情報をフォームからお送りください"
  },
  {
    step: 2,
    title: "社内審査",
    description: "パートナーシップの適合性を慎重に検討します"
  },
  {
    step: 3,
    title: "ご相談",
    description: "詳細なご説明と、ご質問にお答えします"
  },
  {
    step: 4,
    title: "パートナーシップ開始",
    description: "合意に至れば、ブランドパートナーとして運営を開始"
  }
];

export const targetMarket = {
  title: "ファミリー旅行市場に特化",
  titleEn: "Focused on Family Travel",
  description: "より大きな予約価値と長期滞在を実現する、高価値セグメントに注力しています",
  features: [
    "5〜30室規模の物件に最適",
    "ファミリー・グループ向け設計",
    "高品質で快適な宿泊体験の提供"
  ]
};

export const whyPartnership = {
  title: "なぜ「パートナーシップ」なのか",
  comparison: [
    {
      type: "従来の物件管理",
      isAcoe: false,
      points: [
        "固定費用型の料金体系",
        "オーナー様が全リスクを負担",
        "結果と報酬が連動しない",
        "業者・下請けの関係性",
        "ノーブランドで市場での差別化が困難"
      ]
    },
    {
      type: "ACOEブランドパートナーシップ",
      isAcoe: true,
      points: [
        "成果報酬型の料金体系",
        "リスクと報酬を共有",
        "パフォーマンスに連動した報酬",
        "長期運営パートナーの関係性",
        "ファミリー層への明確なポジショニング"
      ]
    }
  ]
};

export const eligibilityForm = {
  title: "パートナーシップ適合性チェック",
  titleEn: "Partnership Eligibility Check",
  subtitle: "まずは物件情報をお聞かせください。適合性を確認の上、ご連絡いたします。",
  note: "※ 大量営業は行いません。明確な適合性が確認できた物件にのみご連絡いたします。",
  fields: [
    { name: "name", label: "お名前", type: "text", required: true },
    { name: "email", label: "メールアドレス", type: "email", required: true },
    { name: "phone", label: "電話番号", type: "tel", required: false },
    { name: "propertyType", label: "物件タイプ", type: "select", required: true,
      options: ["一棟ビル", "マンション複数室", "戸建て", "その他"]
    },
    { name: "roomCount", label: "部屋数", type: "select", required: true,
      options: ["5室未満", "5〜10室", "11〜20室", "21〜30室", "30室以上"]
    },
    { name: "prefecture", label: "都道府県", type: "text", required: true },
    { name: "city", label: "市区町村", type: "text", required: true },
    { name: "address", label: "町名・番地", type: "text", required: true },
    { name: "buildingName", label: "ビル名・マンション名（任意）", type: "text", required: false },
    { name: "currentStatus", label: "現在の運営状況", type: "select", required: true,
      options: ["未運営（これから開始）", "自主運営中", "他社委託中", "休止中"]
    },
    { name: "message", label: "ご質問・補足事項", type: "textarea", required: false }
  ]
};

export const footerContent = {
  copyright: "© 2025 ACOE. All rights reserved.",
  tagline: "東京発、ライフスタイル宿泊ブランド",
  links: [
    { label: "ホーム", href: "#" },
    { label: "パートナーシップについて", href: "#partnership" },
    { label: "お問い合わせ", href: "#contact" }
  ]
};
